export default {
    title: "Tu Experiencia Personalizada",
    loading1: "Configurando",
    loading2: "Analizando tus pedidos",
    loading3: "Generando Recomendaciones",
};
